'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClosePopUps = function () {
    function ClosePopUps() {
        _classCallCheck(this, ClosePopUps);
    }

    _createClass(ClosePopUps, null, [{
        key: 'close',
        value: function close() {
            if (document.getElementById('popupContainer')) {
                if (document.getElementById('popupContainer').children.length === 0) {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('messageContainer'));
                } else {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                }
            } else {
                if (document.getElementById('messageContainer')) {
                    if (document.getElementById('messageContainer').children.length === 0) {
                        _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                    } else {
                        _reactDom2.default.unmountComponentAtNode(document.getElementById('messageContainer'));
                    }
                }
            }
        }
    }]);

    return ClosePopUps;
}();

exports.default = ClosePopUps;